import React from "react";
import EnrichedTrackingView from "../EnrichedTrackingView";

const EnrichedShipmentDetailsUI = ({ endpoint, awbNumber }) => (
  <EnrichedTrackingView endpoint={endpoint} awbNumber={awbNumber} showBackArrow={false} />
);

export default EnrichedShipmentDetailsUI;
